import axios from "axios"
import siteConfig from "@/utils/siteConfig"

export default {
  auth: {
    user: {},
  },
  async login(email, password) {
    const data = await axios({
      method: "post",
      url: `${siteConfig.siteURL}users/login/legacy`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: { email, password },
    })
    return data
  },
  async register(email, password, fullName) {
    const data = await axios({
      method: "post",
      url: `${siteConfig.siteURL}users/register/legacy`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: { email, password, full_name: fullName },
    })
    return data
  },
  logout() {},
}
